import DataApi from './DataApi';

function tabsApi() {
  return new DataApi('tabs');
}

/**
 * Authorized nav tabs without per-user hide/order applied (Manage Tabs editor).
 */
export async function fetchAuthorizedTabsForEdit() {
  const res = await tabsApi().fetchAll(
    'is_active=true&platform=web&skip_personalization=true'
  );
  if (res?.data?.success && Array.isArray(res.data.data)) {
    return res.data.data;
  }
  return [];
}

export async function fetchTabPreferences() {
  const res = await tabsApi().get('/preferences');
  if (res?.data?.success && Array.isArray(res.data.data)) {
    return res.data.data;
  }
  return [];
}

export async function saveTabPreferences(preferences) {
  const res = await tabsApi().put('/preferences', { preferences });
  return res?.data;
}
